'use client';

import { ComponentPropsWithoutRef, useLayoutEffect } from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import { useModalContext } from './modal-context';
import './modal.scss';

type Props = ComponentPropsWithoutRef<typeof Layout>;
export const ModalTitle = ({ children, className, ...props }: Props) => {
    const { modalId } = useModalContext();

    useLayoutEffect(() => {
        document
            .getElementById(`modal-${modalId}-wrapper`)
            ?.setAttribute('aria-labelledby', `modal-${modalId}-title`);

        return () => {
            document.getElementById(`modal-${modalId}-wrapper`)?.removeAttribute('aria-labelledby');
        };
    }, []);

    return (
        <Layout
            element="h2"
            id={`modal-${modalId}-title`}
            className={cn('modal__title', className)}
            {...props}
        >
            {children}
        </Layout>
    );
};
